import type { DatetimeString } from '#/types/TypedDateString';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import { SALARIES_API_ENDPOINT_ROOT } from './salaryApiEndpointRoot';

type ApiResponse = {
  alreadySubmitted: boolean;
  salaryModelCreated: DatetimeString;
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => SALARIES_API_ENDPOINT_ROOT,
  mapResponse,
});

// Exports

export const salaryApiGetCompensationSurvey = endpoint.createClientFetchFn();

export const salaryApiIsomorphicFetchCompensationSurvey =
  endpoint.createIsomorphicFetchFn();
